import {http} from "../utils/http";
import {Response} from '../types/resp';
import { GameStatus } from '../types/game';

export const game = {
	providerList: async () => {
		return http.get<Response<any>>('/games/provider-list')
	},

	recommended: async () => {
		return http.get<Response<any>>('/games/recommended')
	},

	listByType: async (payload: any) => {
		return http.post<Response<any>>('/games/list-by-type', payload)
	},

	listByCode: async (payload: any) => {
		return http.post<Response<any>>('/games/list-by-code', payload)
	},

	login: async (payload: any) => {
		return http.post<Response<any>>('/games/login', payload)
	},

	status: async () => {
		return http.get<Response<GameStatus>>('/games/status')
	},

	sport: async (payload: any) => {
		return http.post<Response<any>>('/games/sportPost', payload)
	},

	recently: async () => {
		return http.get<Response<any>>('/games/recently')
	},

	favorite: async () => {
		return http.get<Response<any>>('/games/fav')
	},

	favoriteAdd: async (id: string) => {
		return http.post<Response<any>>('/games/fav/add/' + id, {})
	},

	favoriteDelete: async (id: string) => {
		return http.post<Response<any>>('/games/fav/del/' + id, {})
	},

	liveStream: async () => {
		return http.get<Response<any>>('/liveStream')
	},
}
